import { useState } from "react";
import styled from "styled-components";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import FadeInOnScroll from "../components/FadeInOnScroll";
import AlternateBand from "../components/AlternateBand";

const CallNowBox = styled.div`
  max-width: 330px;
  min-height: 300px;
  height: auto;
  background: #2f3630;
  border-radius: 10px;
  text-align: left;
  padding: 20px 30px;
  font-family: "Open Sans", sans-serif;
  margin-top: 60px;

  @media screen and (max-width: 1000px) {
    width: 100%; /* Make it full width on smaller screens */
    margin-top: 10px;
    margin-bottom: 30px;
  }
`;

const CallNumber = styled.a`
  color: #2f3630;
  font-size: 24px;
  font-weight: 400;
  line-height: 1;

  position: relative;
  padding-right:  30px;
  cursor: pointer;
  text-decoration: none;

  &::after {
    padding-bottom:  0px;
    content: url("../images/arrow.svg");
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: right ease 0.4s;
  }

  &:hover {
    opacity: 0.8;
    &::after {
      right: -10px;
    }
  }
  &:active {
    opacity: 0.5;
  }
`;

const CallNowText = styled.div`
  font-size: 24px;
  line-height: 1;
  color: #ffffff;
  padding: 5px;
`;

const ArrowLink = styled.a`
  color: #5e8a64;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.3;

  position: relative;
  padding-right: 40px;
  cursor: pointer;
  text-decoration: none;

  &::after {
    content: url("../images/arrow.svg");
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: right ease 0.4s;
  }

  &:hover {
    opacity: 0.8;
    &::after {
      right: -10px;
    }
  }
  &:active {
    opacity: 0.5;
  }
`;

const ArrowLinkCircle = styled.a`
  cursor: pointer;

  img {
    transition: transform ease 0.4s;

    &:hover {
      opacity: 0.8;
      transform: scale(1.04);
    }
    &:active {
      opacity: 0.5;
      transition: none;
      transform: scale(1);
    }
  }
`;

const Hero = styled.div`
  #hero {
    color: #2F3630;
    padding: 10px 30px 20px;
    position: relative;
  }

  @media screen and (max-width: 970px) {
    #hero {
      padding: 5px 5px;
      position: relative;
    }
  }

  #hero #hero-graphic {
    position: absolute;
    right: 0;
    bottom: -20px;
  }

  @media screen and (max-width: 1200px) {
    #hero #hero-graphic {
      right: 30px;
      bottom: 73px;
    }
  }

  @media screen and (max-width: 970px) {
    #hero #hero-graphic {
      position: relative;
      right: unset;
      bottom: unset;
      max-width: 400px;
      width: 90%;
      display: block;
      margin: auto;
    }
  }

  #hero .wrap {
    width: 1184px;
    margin: auto;
    position: relative;
    z-index: 2;
  }

  #hero .inner-wrap {
    flex-direction: column;
    display: flex;
  }

  @media screen and (max-width: 970px) {
    #hero .inner-wrap {
      align-items: center;
      text-align: center;
      margin: 0 auto 5px;
    }
  }

  #hero .inner-wrap p {
    margin: 10px 0;
    font-size: 24px;
  }

  #hero h1 {
    width: 100%;
    text-align: center;
  }

  #hero p {
    text-align: center;
  }

  @media screen and (max-width: 1050px) {
    #hero .inner-wrap p {
      max-width: 100%;
    }
  }
`;

const TopCardText = styled.p`
  color: #5E8A64;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.27;
`;

const BottomCardText = styled.p`
  color: #5E8A64;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.27;
`;

const TriColumnPhotos = styled.div`
  .tri-photo-column {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 10px 30px 10px;
  }

  .tri-photo-column .item {
    width: 175px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px;
  }
  .tri-photo-column .item img {
    width: 100px;
    height: 100px;
    border-radius: 20px;
    padding: 5px;
  }
  .tri-photo-column .item p {
    text-align: center;
  }
  .tri-photo-column .item a {
    border: 3px solid #5E8A64;
    border-radius: 20px;  
  }
`;

const ImproveWellbeing = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1184px;
  padding: 0 30px;

  img {
    width: 447px;
  }

  .text-block {
    width: 652px;
  }

  .text-block p {
    margin: 30px 30px 30px 0;
  }

  @media screen and (max-width: 970px) {
    flex-direction: column;
    text-align: center;
    flex-direction: column-reverse;

    img {
      margin: 0 auto 50px;
      max-width: 90%;
    }

    .text-block p {
      margin: 30px auto;
    }
  }
`;

const TrustedProfessionals = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1184px;
  padding: 0 30px;

  img {
    width: 466px;
    margin-right: 60px;
  }

  .text-block {
    width: 654px;
  }

  .text-block p {
    margin: 30px 30px 30px 0;
  }

  @media screen and (max-width: 970px) {
    flex-direction: column;
    text-align: center;

    img {
      margin: 0 auto 50px;
      max-width: 90%;
    }

    .text-block p {
      margin: 30px auto;
    }
  }
`;

const TriColumnIcons = styled.div`
  .tri-icon-column {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 90px 30px 50px;
  }

  .tri-icon-column .item {
    width: 317px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 50px;
  }

  .tri-icon-column .item img {
    margin-bottom: 30px;
  }

  .tri-icon-column .item h3 {
    color: #5e8a64;
    text-align: center;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 1;
  }

  .tri-icon-column .item p {
    color: #2f3630;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.4;
    margin: 30px 0;
  }
`;

function Home() {

  const [menuOpen, setMenuOpen] = useState(false);
  const [getStartedOpen, setGetStartedOpen] = useState(false);

  const handleGetStartedClick = () => {
    setGetStartedOpen(true);
    setMenuOpen(false);
  };

  return (
    <FadeInOnScroll>
      <div className="green-bg">
        <Nav />
      </div>
      
      <main>
      <Hero className="green-bg">
          <section id="hero">
            <div className="wrap">
              <div className="inner-wrap">
                <h1>Community Wellness Services</h1>
                <p>Click on a card below to find service providers.</p>
              </div>
          </div>
          </section>
      </Hero>
      
      <TriColumnPhotos className="green-bg">
          <section className="tri-photo-column">
            <div className="item">
              <TopCardText>THERAPY</TopCardText>
              <a href="/talktherapy">
                <img
                src="images/talk-therapy.svg"
                alt="Talk Therapy Icon"
                />
              </a>
            </div>
            <div className="item">
              <TopCardText>MASSAGE</TopCardText>
              <a href="/massagetherapy">
                <img
                  src="images/massage-therapy.svg"
                  alt="Message Therapy Icon"
                />
              </a>
            </div>
            <div className="item">
              <TopCardText>ADDICTION</TopCardText>
              <a href="/substanceaddiction">
                <img
                  src="images/addiction-services.svg"
                  alt="Addiction Services Icon"
                />
              </a>
            </div>
            <div className="item">
              <TopCardText>CHARITIES</TopCardText>
              <a href="/charities">
                <img
                  src="images/charities.svg"
                  alt="Charities Icon"
                />
              </a>
            </div>
             <div className="item">
              <TopCardText>PSYCHOLOGY</TopCardText>
              <a href="/psychology">
                <img
                  src="images/psychology.svg"
                  alt="Psychology Icon"
                />
              </a>
            </div>
             <div className="item">
              <TopCardText>COACHING</TopCardText>
              <a href="/coaching">
                <img
                  src="images/coaching.svg"
                  alt="Coaching Icon"
                />
              </a>
            </div>
          </section>
        </TriColumnPhotos>

      </main>
      <AlternateBand>
          Our VISION is a mindful and supportive community of connected individuals helping each other find their inner ZEN.
      </AlternateBand>
      <Footer />
    </FadeInOnScroll>
  );
}

export default Home;
